const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

const wholeCurrencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const formatterByCurrencyCode = new Map<string, Intl.NumberFormat>()

function resolveFormatter(currencyCode?: string): Intl.NumberFormat {
  if (!currencyCode) return currencyFormatter
  const code = currencyCode.toUpperCase()
  const cached = formatterByCurrencyCode.get(code)
  if (cached) return cached
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: code,
  })
  formatterByCurrencyCode.set(code, formatter)
  return formatter
}

export function formatCurrency(value: number, currencyCode?: string): string {
  const formatter = resolveFormatter(currencyCode)
  if (!Number.isFinite(value)) return formatter.format(0)
  return formatter.format(value)
}

export function formatCurrencyWhole(value: number): string {
  if (!Number.isFinite(value)) return wholeCurrencyFormatter.format(0)
  return wholeCurrencyFormatter.format(value)
}
